import { render, staticRenderFns } from "./bundle_product.vue?vue&type=template&id=50dcdf6e&scoped=true"
import script from "./bundle_product.vue?vue&type=script&lang=js"
export * from "./bundle_product.vue?vue&type=script&lang=js"
import style0 from "./bundle_product.vue?vue&type=style&index=0&id=50dcdf6e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dcdf6e",
  null
  
)

export default component.exports